module.exports = __webpack_public_path__ + "static/media/5.c8e64079.svg";